<template>
  <vs-card>
    <div slot="header">
      <h3 class="w-full text-center">{{counterName}}</h3>
    </div>
    <div>
      <div class="vx-row">
        <template v-if="status == 'call' || status == 'on_service'">
          <div
            class="vx-col w-full text-center text-primary text-6xl mt-4"
          >{{queue.ticket_code || 'Not Set'}}</div>
          <div class="vx-col w-full text-center text-xl mb-4">{{queue.customer_name || 'Not Set'}}</div>
        </template>
        <template v-if="status != 'call' && status != 'on_service'">
          <div class="vx-col w-full text-center text-6xl mt-4">
            <feather-icon
              v-if="status == 'finish'"
              icon="CheckIcon"
              class="text-success"
              svgClasses="h-24 w-24"
            ></feather-icon>

            <feather-icon
              v-else
              icon="AlertTriangleIcon"
              class="text-primary"
              svgClasses="h-24 w-24"
            ></feather-icon>
          </div>
          <div
            v-if="queue != null"
            class="vx-col w-full text-center text-lg"
          >Silahkan panggil antrian selanjutnya</div>
          <div v-else class="vx-col w-full text-center text-lg">Tidak Ada Antrian</div>
        </template>
        <!-- <div
          class="vx-col w-full flex justify-between text-center my-5 text-xl"
          v-if="status != 'call' && status != 'on_service' && queues.length > 0"
        > -->
        <div
          class="vx-col w-full flex justify-between text-center my-5 text-xl"
          v-if="status != 'call' && status != 'on_service' && queue != null"
        >
          <vs-button
            @click="call"
            color="rgb(62, 201, 214)"
            class="w-full"
            type="filled"
            icon-pack="feather"
            icon="icon-phone-call"
          >
            <span>Panggil</span>
          </vs-button>
        </div>
        <div
          v-if="status == 'call'"
          class="vx-col w-full flex justify-between text-center text-xl mt-5"
        >
          <vs-button
            color="rgb(62, 201, 214)"
            type="filled"
            icon-pack="feather"
            icon="icon-refresh-ccw"
            @click="call"
          >
            <span v-if="true">Panggil</span>
          </vs-button>

          <vs-button
            @click="transfer"
            color="warning"
            type="filled"
            icon-pack="feather"
            icon="icon-repeat"
            :disabled="true"
          >
            <span v-if="true">Pindah</span>
          </vs-button>
        </div>
        <div v-if="status == 'call'" class="vx-col w-full text-center text-xl pt-5">
          <vs-button
            @click="onService"
            class="w-full mb-2"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-check"
          >
            <span>Dilayani</span>
          </vs-button>
          <vs-button
            @click="skip"
            class="w-full"
            color="danger"
            type="flat"
            icon-pack="feather"
          >
            <span v-if="true" class="text-lg font-semibold">Lewati</span>
          </vs-button>
        </div>
        <div v-if="status == 'on_service'" class="vx-col w-full text-center text-xl pt-5">
          <vs-button
            @click="finish"
            class="w-full mb-2"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-check"
          >
            <span>Selesai</span>
          </vs-button>
        </div>
      </div>
    </div>
    <transfer :bus="bus" :counter="{id: counterId, name: counterName}" />
    <popup-add-queue 
      v-if="laperonService != null" 
      :active.sync="popupAdd" 
      :services="laperonService"
      :url="queueRegistrationUrl"
      :customerId="queue.customer_id"
    />
  </vs-card>
</template>
<script>
import Transfer from "./Transfer";
import PopupAddQueue from '@/components/queue/PopupAddQueue.vue';

export default {
  props: {
    counterId: {
      required: true
    },
    counterName: {
      required: true
    },
    queues: {
      required: true,
      default: () => {
        return [];
      },
      type: Array
    },
    bus: {
      type: Object
    },
    laperonService: {
      type: Object,
      required : false
    }
  },
  components: {
    Transfer,
    PopupAddQueue,
  },
  data() {
    return {
      status: "",
      queue: null,
      lastCallQueue: {},
      popupActive : false,
      popupAdd : false,
      queueRegistrationUrl : `/app/secure/counter-process/store-queue-registration`,
    };
  },
  methods: {
    action(param) {
      this.status = param;
    },
    call() {
      this.$vs.loading();
      this.$http
        .post(`/app/secure/counter-process/call`, {
          queue_id: this.queue.queue_id,
          counter_id: this.counterId
        })
        .then(() => {
          this.bus.$emit("reloadQueue");
        })
        .catch(e => {
          this.parseError(e);
          this.abortQueue();
        })
        .finally(() => {
          this.$vs.loading.close();
        });
      this.status = "call";
    },
    finish() {
      this.$vs.loading();
      this.$http
        .post(`/app/secure/counter-process/finish`, {
          queue_id: this.queue.queue_id,
          counter_id: this.counterId
        })
        .then(() => {
          this.bus.$emit("reloadQueue");
          this.status = "";
          this.queue = null;
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    onService() {
      this.$vs.loading();
      this.$http
        .post(`/app/secure/counter-process/serve`, {
          queue_id: this.queue.queue_id,
          counter_id: this.counterId
        })
        .then(() => {
          this.bus.$emit("reloadQueue");
          this.status = "on_service";
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    transfer() {
      this.bus.$emit("openTransfer", this.queue);
    },
    skip() {
      this.$vs.loading();
      this.$http
        .post(`/app/secure/counter-process/skip`, {
          queue_id: this.queue.queue_id,
          counter_id: this.counterId
        })
        .then(() => {
          this.bus.$emit("reloadQueue");
          this.status = "skip";
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    abortQueue(){
      if(this.queues.length <= 1){
        window.location.reload();
      }
      else{
        this.bus.$emit('reloadQueue');
      }
    }
  },
  watch: {
    queues: {
      deep: true,
      handler(val) {
        val.some(item => {
          if (item.status == "calling" && item.counter_id == this.counterId) {
            this.queue = item;
            this.status = "call";
            return true;
          } else if (item.status == "calling" && item.counter_id == null) {
            this.queue = item;
            this.status = "";
            return true;
          } else if (
            item.status == "on_service" &&
            item.counter_id == this.counterId
          ) {
            this.queue = item;
            this.status = "on_service";
            return true;
          } else if (item.status == "waiting" && item.counter_id == null) {
            this.queue = item;
            this.status = "";
            return true;
          }
        });
      }
    }
  }
};
</script>